import { Component, ViewChild, OnInit, ElementRef } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../../common/global-constants';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { catchError, retry } from 'rxjs/operators';
import { ApiMethod } from '../../apimethods/api-method';
import { HttpClient } from '@angular/common/http';
declare var $;

@Component({
  selector: 'app-child-view-grid',
  templateUrl: './child-view-grid.component.html',
  styleUrls: ['./child-view-grid.component.css']
})
/** childViewGrid component*/
export class ChildViewGridComponent implements OnInit {
  showModal: boolean;
  dataTable: any;
  /*  tableDataArticle = [];*/
  @ViewChild('dataTable', { static: false }) table;
  dataSetDefectRes: any;

  dataSet: any;
  ajournalCt = [];
  journal: any = 0;
  defectstatus: any = 'All';
  disableScrollDown = false;

  journalName: any;
  volumeIssue: any;
  articleNo: any;
  defectAreaName: any;
  defectCategory: any;
  defectInstructions: any;
  responsibleUser: any;
  complaintType: any;
  currentStatus: any;
  criticalStatus: any;
  implementDate: any;
  problemDate: any;
  defectDueDate: any;
  dueStatus: any;
  description: any;
  rootCause: any;
  daysOnDue: any;

  rootCauseBy: any;
  rootCauseDate: any;
  preventiveAct: any;
  preventiveActBy: any;
  preventiveActDate: any;
  correctiveAction: any;
  correctiveActBy: any;
  correctiveActDate: any;
  feedback: any;
  DaysOnDue: any;
  constructor(private router: Router, http: HttpClient) {


  }

  ngOnInit(): void {
    this.getJournalAllList();
  }

  NavigateToDefectMgt(): void {
    let nPublisherId = localStorage.aPubID;
    let defectId = localStorage.aEID;
    this.router.navigate(
      ['/defect-mgt'],
      { queryParams: { DefectId: defectId, PublisherId: nPublisherId } }
    );
  }

  ShowDataResponse(): void {

    $("#LoadingImage").show();

    if (localStorage.aEID != 0) {

      var dataParam = {
        PublisherID: localStorage.aPubID,
        defectId: localStorage.aEID

      };


    }
    ApiMethod.postMethod('api/defectResponseDetails', dataParam).subscribe(
      response => {

        let defectDetails = response.defectDetailsById;
        //Show Data
        if (defectDetails.length != 0) {
          this.journalName = defectDetails[0].Acronym;
          this.volumeIssue = defectDetails[0].IssueId;
          this.articleNo = defectDetails[0].ArticleNo;
          this.defectAreaName = defectDetails[0].AreaName;
          this.defectCategory = defectDetails[0].category;
          this.defectInstructions = defectDetails[0].Instructions;
          this.responsibleUser = defectDetails[0].ResponsiblePerson;
          this.complaintType = defectDetails[0].complaintType;
          this.currentStatus = defectDetails[0].currentstatus;
          this.criticalStatus = defectDetails[0].CriticalLevel;
          this.implementDate = GlobalConstants.SetValue_FormatDate(defectDetails[0].ImplementDate);
          this.problemDate = GlobalConstants.SetValue_FormatDate(defectDetails[0].Problemdate);
          this.defectDueDate = GlobalConstants.SetValue_FormatDate(defectDetails[0].DefectDueDate);
          this.dueStatus = defectDetails[0].DueStatus;
          this.description = defectDetails[0].Description;
          this.rootCause = defectDetails[0].RootCasue;
          this.rootCauseBy = defectDetails[0].rootcasueby;
          this.rootCauseDate = GlobalConstants.SetValue_FormatDate(defectDetails[0].RootCasueDate);
          this.preventiveAct = defectDetails[0].PreventiveAction;
          this.preventiveActBy = defectDetails[0].preventiveActionBy;
          this.preventiveActDate = GlobalConstants.SetValue_FormatDate(defectDetails[0].PreventiveActionDate);
          this.correctiveAction = defectDetails[0].CorrectiveAction;
          this.correctiveActBy = defectDetails[0].correctiveactionby;
          this.correctiveActDate = GlobalConstants.SetValue_FormatDate(defectDetails[0].CorrectiveActionDate)
          this.feedback = defectDetails[0].ProductionResponse;
          this.daysOnDue = Math.abs(defectDetails[0].DaysOnDue);
        }

        $("#LoadingImage").hide();

      },
      error => {
        ngswal("Failed !", error.message, "error");
        $("#LoadingImage").hide();
      }

    );
    this.showModal = true;
  }
  hide() {
    this.showModal = false;
  }

  getJournalAllList(): void {

    this.journal = 2;
    this.defectstatus = 'All';

    var paramData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID,
      journal: this.journal,
      defectstatus: this.defectstatus

    };

    ApiMethod.postMethod('api/journalDetails', paramData).subscribe(
      result => {
        var jrnArticleStageList = result.journalDetails;
        var journalCount = result.journalDetails.length;

        this.dataSet = JSON.stringify(result.journalDetails); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let aColList = result.aColListL;
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.aNewButtonName = 'btn_AddNew';
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 200);
        dataItem.modulename = 'DefecMgtDashboard';
        dataItem.rowSelect = true;

        dataItem.infoPopupID = "Id";
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#LoadingImageDashArt").hide();
      },
      error => {
        $("#LoadingImageDashArt").hide();
        ngswal("Failed !", error.message, "warning");
      }
    );
  }
}

